export default __webpack_public_path__ + "static/media/logo_ths.fc532c09.webp";